import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CMSContent, logError } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const PageNotFound = ({ user, config, cmsSourceFirebase, actions, match }) => {
    useEffect(() => {
        logError({
            errorCode: 'PAGE_NOT_FOUND',
            severity: 'error',
            category: 'generic',
            user,
            config,
        });
    }, []);

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <div className='container-fluid'>
                <div className='row justify-content-center'>
                    <div className='entry-box col-10'>
                        <h2 className='text-center my-4'>
                            <CMSContent
                                localStorageObject='webContent'
                                contentPath='data.sitewideSettings.pageNotFound.contentHeaderText'
                                cmsSourceFirebase={cmsSourceFirebase}
                            />
                        </h2>
                        <div>
                            <CMSContent
                                localStorageObject='webContent'
                                contentPath='data.sitewideSettings.pageNotFound.contentHTML'
                                cmsSourceFirebase={cmsSourceFirebase}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
